import {Component, Input} from '@angular/core';
import {Services} from '../../../../../model/services';
import {TextsComponent} from '../../../../elements/texts/texts.component';

@Component({
  selector: 'app-about-el',
  imports: [
    TextsComponent
  ],
  templateUrl: './about-el.component.html',
  styleUrl: './about-el.component.scss'
})
export class AboutElComponent {

  @Input() el: Services = new Services();

  get background() {
    return `background: url("${this.el.img}") no-repeat fixed center / cover;`
  }

  get label() {
    return this.el.title
  }

  get subtitleRus() {
    if (this.el?.subtitle === undefined) {
      return ''
    }
    return this.el.subtitle[0]
  }

  get subtitleEn() {
    if (this.el?.subtitle === undefined) {
      return ''
    }
    return this.el.subtitle[1];
  }

}
